/* Returns unique interested users sorted by the number of times the user appears in featureInterest (most to fewest),
and with the current user always at the end.
We want the current user at the end because it is more relevant to show other users ahead of the current user. */
export const getSortedUniqueInterestedUsers = (featureInterest, currentUserEmail) => {
  if (!featureInterest || featureInterest.length === 0) return [];
  const emailCounts = {};
  let currentUserInfo = null;
  for (const feature of featureInterest) {
    if (!feature.hubSpotUserInfo) continue;
    for (const user of feature.hubSpotUserInfo) {
      if (user.email !== currentUserEmail) {
        if (emailCounts[user.email]) {
          emailCounts[user.email].count += 1;
        } else {
          emailCounts[user.email] = {
            count: 1,
            user
          };
        }
      } else if (!currentUserInfo) {
        currentUserInfo = user;
      }
    }
  }
  const sortedUsers = Object.values(emailCounts).sort((a, b) => b.count - a.count).map(info => info.user);
  if (currentUserInfo) {
    sortedUsers.push(currentUserInfo);
  }
  return sortedUsers;
};